import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { LoginModalContent } from '../../models/aem';
import { StoredQuestionsResponse } from '../../models/recover-by-sqa.interface';
import { RecoverSqaHelperService } from '../../services/recover-sqa-service/recover-sqa-helper.service';

@Injectable({
  providedIn: 'root'
})
export class RecoverSQAAdapterService {
  securityQuestionsForRecoveryForm!: UntypedFormGroup;
  constructor(private helper: RecoverSqaHelperService) {}

  async recoverSQAAdapterScreenContent(
    loginAemResponse: LoginModalContent,
    sqaStoredQuestionList: StoredQuestionsResponse
  ) {
    return {
      formGroup: this.helper.createSecurityQuestionsForRecoveryForm(),
      sqaStoredQuestionList: sqaStoredQuestionList,
      sqaFormAttributes: this.helper.getSQAFormAttributes(),
      pageContent: this.helper.getSQARecoveryScreenContent(loginAemResponse),
      disableButton: false
    };
  }
}
